import { createRouter, createWebHistory } from "@ionic/vue-router";
import { RouteRecordRaw } from "vue-router";
import "vue-router";
import HomeTabs from "@/views/HomeTabs.vue";
import Auth from "./routes/auth";
import authMiddleware from "./utils/middleware/_auth";

// Logged in
import "vue-router";

declare module "vue-router" {
    interface RouteMeta {
        // is optional
        middleware?: (context: any) => void;
    }
}

const routes: Array<RouteRecordRaw> = [
    ...Auth,
    {
        path: "/",
        redirect: "/tabs/livescores",
        meta: {
            middleware: authMiddleware,
        },
    },
    {
        path: "/tabs/",
        component: HomeTabs,
        meta: {
            middleware: authMiddleware,
        },
        children: [
            // Livescores tab routes
            {
                name: "livescores.index",
                path: "livescores",
                alias: "/livescores",
                component: () =>
                    import("@/views/livescores/LivescoresShow.vue"),
                meta: {
                    tab: "livescores",
                },
            },
            {
                name: "livescores.games.show",
                path: "livescores/games/:id",
                alias: "/livescores/games/:id",
                component: () =>
                    import("@/views/livescores/games/GameShow.vue"),
                meta: {
                    tab: "livescores",
                },
            },
            {
                name: "livescores.season.show",
                path: "livescores/season/:seasonId",
                alias: "/livescores/season/:seasonId",
                component: () => import("@/views/livescores/SeasonShow.vue"),
                meta: {
                    tab: "livescores",
                },
            },
            {
                name: "livescores.teams.show",
                path: "livescores/teams/:teamId",
                alias: "/livescores/teams/:teamId",
                component: () =>
                    import("@/views/livescores/teams/TeamShow.vue"),
                meta: {
                    tab: "livescores",
                },
            },
            // Groups tab routes
            {
                name: "groups.index",
                path: "groups",
                component: () => import("@/views/groups/GroupIndex.vue"),
                meta: {
                    tab: "groups",
                },
            },
            {
                name: "groups.rules",
                path: "groups/rules",
                component: () => import("@/views/content/PouleRules.vue"),
                meta: {
                    tab: "groups",
                },
            },
            {
                name: "groups.show",
                path: "groups/:groupId",
                component: () => import("@/views/groups/GroupShow.vue"),
                meta: {
                    tab: "groups",
                },
            },
            {
                name: "groups.create",
                path: "groups/create",
                component: () => import("@/views/groups/GroupCreate.vue"),
                meta: {
                    tab: "groups",
                },
            },
            {
                name: "groups.sub-group-picker",
                path: "groups/:groupId/sub-group",
                component: () => import("@/views/groups/SubGroupPicker.vue"),
                meta: {
                    tab: "groups",
                },
            },
            {
                name: "groups.formula1.show",
                path: "groups/formula1/:groupId",
                component: () =>
                    import("@/views/groups/formula1/GroupShow.vue"),
                meta: {
                    tab: "groups",
                },
            },
            {
                name: "groups.formula1.race.show",
                path: "groups/formula1/:groupId/race/:raceId",
                component: () => import("@/views/groups/formula1/RaceShow.vue"),
                meta: {
                    tab: "groups",
                },
            },
            // Profile tab routes
            {
                name: "profile.show",
                path: "profile",
                component: () => import("@/views/profile/ProfileShow.vue"),
                meta: {
                    tab: "profile",
                },
            },
            {
                name: "profile.information",
                path: "profile/information",
                component: () =>
                    import("@/views/profile/ProfileInformation.vue"),
                meta: {
                    tab: "profile",
                },
            },
            {
                name: "profile.subscription",
                path: "profile/subscription",
                component: () =>
                    import("@/views/profile/ProfileSubscription.vue"),
                meta: {
                    tab: "profile",
                },
            },
            {
                name: "profile.password",
                path: "profile/password",
                component: () => import("@/views/profile/ProfilePassword.vue"),
                meta: {
                    tab: "profile",
                },
            },
            {
                name: "profile.settings",
                path: "profile/settings",
                component: () => import("@/views/profile/ProfileSettings.vue"),
                meta: {
                    tab: "profile",
                },
            },
            {
                name: "profile.settings.topic",
                path: "profile/settings/:topic",
                component: () =>
                    import("@/views/profile/ProfileSettingsTopic.vue"),
                meta: {
                    tab: "profile",
                },
            },
            // Other routes that don't belong to specific tabs but need to be within the tab structure
            {
                name: "auth.invited-by-link",
                path: "/poules/share/:token",
                component: () => import("@/views/groups/GroupJoin.vue"),
                meta: {
                    tab: "groups",
                },
            },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(""),
    routes,
});

router.beforeEach((to, from, next) => {
    if (!to.meta.middleware) {
        return next();
    }

    const context = {
        to,
        from,
        next,
    };

    return to.meta.middleware({
        ...context,
    });
});

export default router;
